export default class TravelServiceOrderItemCar {
  start_place_id = null;
  end_place_id = null;
  start_date = null;
  start_time = null;
  end_date = null;
  end_time = null;
  car_class = null;
  is_insurance = false;
}
